(() => {
  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => [...root.querySelectorAll(selector)];

  const header = qs('[data-header]');
  const updateHeader = () => header?.classList.toggle('scrolled', window.scrollY > 24);
  if (header?.classList.contains('site-header')) {
    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
  }

  const menuButton = qs('[data-menu-toggle]');
  const mobileNav = qs('[data-mobile-nav]');
  const closeMenu = () => {
    menuButton?.setAttribute('aria-expanded', 'false');
    menuButton?.setAttribute('aria-label', 'Open menu');
    mobileNav?.classList.remove('open');
    document.body.classList.remove('menu-open');
  };
  menuButton?.addEventListener('click', () => {
    const opening = menuButton.getAttribute('aria-expanded') !== 'true';
    menuButton.setAttribute('aria-expanded', String(opening));
    menuButton.setAttribute('aria-label', opening ? 'Close menu' : 'Open menu');
    mobileNav?.classList.toggle('open', opening);
    document.body.classList.toggle('menu-open', opening);
  });
  mobileNav?.addEventListener('click', (event) => { if (event.target.closest('a')) closeMenu(); });
  qs('[data-back]')?.addEventListener('click', () => {
    if (history.length > 1) history.back();
    else location.href = `${window.arcadia?.rootUrl || '/'}#collection`;
  });

  const previewCardFinish = (button) => {
    const card = button?.closest('[data-product-card]');
    if (!card) return;
    const image = qs('[data-card-image]', card);
    if (button.dataset.cardFinishImage && image) {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = button.dataset.cardFinishImage;
      image.alt = `${image.alt.replace(/ — .+ finish$/, '')} — ${button.dataset.cardFinishName} finish`;
    }
  };

  const catalog = qs('[data-product-grid]');
  if (catalog) {
    const cards = qsa('[data-product-card]', catalog);
    const filters = qs('[data-catalog-filters]');
    const count = qs('[data-product-count]');
    const empty = qs('[data-product-empty]');
    const priceRequests = qsa('[data-price-request]');
    const search = qs('[data-catalog-search]');
    const catalogParams = new URLSearchParams(location.search);
    let system = catalogParams.get('system') || 'all';
    let finish = 'all';
    let query = '';

    const previewVisibleCards = () => {
      cards.filter((card) => !card.hidden).forEach((card) => {
        const link = qs('[data-product-link]', card);
        if (link) {
          const productUrl = new URL(link.dataset.baseProductUrl, location.origin);
          if (finish === 'all') productUrl.searchParams.delete('finish');
          else productUrl.searchParams.set('finish', finish.toUpperCase());
          link.href = `${productUrl.pathname}${productUrl.search}${productUrl.hash}`;
        }
        const finishButton = finish === 'all'
          ? qs('[data-card-finish]', card)
          : qsa('[data-card-finish]', card).find((button) => button.dataset.cardFinishName.toLowerCase() === finish);
        if (finishButton) previewCardFinish(finishButton);
      });
    };
    const render = () => {
      let visible = 0;
      cards.forEach((card) => {
        const matchSystem = system === 'all' || card.dataset.system === system;
        const matchFinish = finish === 'all' || card.dataset.finishes.split(',').includes(finish);
        const matchQuery = !query || card.dataset.search.includes(query);
        const show = matchSystem && matchFinish && matchQuery;
        card.hidden = !show;
        if (show) visible += 1;
      });
      const request = priceRequests.find((item) => item.dataset.priceRequest === system);
      priceRequests.forEach((item) => { item.hidden = item !== request || (query && !item.dataset.search.includes(query)); });
      count.textContent = `${visible} product${visible === 1 ? '' : 's'}`;
      count.parentElement.hidden = Boolean(request);
      catalog.hidden = Boolean(request);
      empty.hidden = visible !== 0 || Boolean(request && !request.hidden);
      previewVisibleCards();
    };

    const clearSelections = () => {
      qsa('[data-filter-system]', filters).forEach((button) => {
        button.classList.remove('active');
        button.setAttribute('aria-pressed', 'false');
      });
      qsa('[data-filter-finish]', filters).forEach((button) => {
        button.classList.remove('active');
        button.setAttribute('aria-pressed', 'false');
      });
      qsa('.profile-group', filters).forEach((group) => group.classList.remove('active'));
    };

    const selectSystem = (button, selectedFinish = button.dataset.defaultFinish || 'all', updateUrl = false) => {
      clearSelections();
      system = button.dataset.filterSystem;
      finish = selectedFinish;
      button.classList.add('active');
      button.setAttribute('aria-pressed', 'true');
      const profile = button.closest('.profile-group');
      const group = button.closest('[data-filter-group]');
      if (profile) profile.classList.add('active');
      if (group) {
        qsa('[data-filter-group]', filters).forEach((item) => item.classList.toggle('open', item === group));
        qsa('[data-material-toggle]', filters).forEach((toggle) => toggle.setAttribute('aria-expanded', String(toggle.closest('[data-filter-group]') === group)));
      } else {
        qsa('[data-filter-group]', filters).forEach((item) => item.classList.remove('open'));
        qsa('[data-material-toggle]', filters).forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));
      }
      const finishButton = profile && qsa('[data-filter-finish]', profile).find((item) => item.dataset.filterFinish === finish);
      if (finishButton) {
        finishButton.classList.add('active');
        finishButton.setAttribute('aria-pressed', 'true');
      }
      render();
      if (updateUrl) {
        const url = new URL(location.href);
        if (system === 'all') url.searchParams.delete('system');
        else url.searchParams.set('system', system);
        if (finish === 'all') url.searchParams.delete('finish');
        else url.searchParams.set('finish', finish);
        history.replaceState({}, '', url);
      }
    };

    qsa('[data-material-toggle]').forEach((button) => button.addEventListener('click', () => {
      const group = button.closest('[data-filter-group]');
      const opening = !group.classList.contains('open');
      qsa('[data-filter-group]', filters).forEach((item) => item.classList.toggle('open', opening && item === group));
      qsa('[data-material-toggle]', filters).forEach((toggle) => toggle.setAttribute('aria-expanded', String(opening && toggle === button)));
    }));
    qsa('[data-filter-system]', filters).forEach((button) => button.addEventListener('click', () => selectSystem(button, undefined, true)));
    qsa('[data-filter-finish]', filters).forEach((button) => button.addEventListener('click', () => {
      const profile = button.closest('.profile-group');
      const systemButton = qs('[data-filter-system]', profile);
      selectSystem(systemButton, button.dataset.filterFinish, true);
    }));
    search?.addEventListener('input', () => { query = search.value.trim().toLowerCase(); render(); });
    const requestedFinish = catalogParams.get('finish')?.toLowerCase();
    const requested = qsa(`[data-filter-system="${CSS.escape(system)}"]`, filters).find((button) => button.closest(`[data-filter-category="${requestedFinish === 'nat' ? 'galvanized-steel' : 'painted-steel'}"]`))
      || qs(`[data-filter-system="${CSS.escape(system)}"]`, filters)
      || qs('[data-filter-system="all"]', filters);
    const availableFinishes = qsa('[data-filter-finish]', requested.closest('.profile-group') || requested).map((button) => button.dataset.filterFinish);
    const validFinish = requestedFinish === requested.dataset.defaultFinish || availableFinishes.includes(requestedFinish);
    selectSystem(requested, validFinish ? requestedFinish : undefined);
  }

  const productRoot = qs('[data-product-root]');
  if (productRoot) {
    const rows = qsa('[data-variant-row]', productRoot);
    const image = qs('[data-product-image]', productRoot);
    const finishButtons = qsa('.finish-button[data-finish]', productRoot);
    const galleryButtons = qsa('[data-gallery-image]', productRoot);
    const selectProductImage = (button) => {
      if (!image) return;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = button.dataset.galleryImage;
      image.alt = button.dataset.galleryAlt;
      galleryButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
    };
    galleryButtons.forEach((button) => button.addEventListener('click', () => selectProductImage(button)));
    const selectProductFinish = (button, updateUrl = false) => {
      const finish = button.dataset.finish;
      finishButtons.forEach((item) => {
        const active = item === button;
        item.classList.toggle('active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      rows.forEach((row) => { row.hidden = row.dataset.finish !== finish; });
      if (button.dataset.image && image) {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = button.dataset.image;
      }
      galleryButtons.forEach((item) => { item.hidden = item.dataset.galleryFinish !== finish; });
      const firstView = galleryButtons.find((item) => !item.hidden);
      if (firstView) selectProductImage(firstView);
      if (updateUrl) {
        const url = new URL(location.href);
        url.searchParams.set('finish', finish);
        history.replaceState({}, '', url);
      }
    };
    finishButtons.forEach((button) => button.addEventListener('click', () => selectProductFinish(button, true)));
    const requestedFinish = new URLSearchParams(location.search).get('finish') || productRoot.dataset.initialFinish;
    const initialFinish = finishButtons.find((button) => button.dataset.finish.toLowerCase() === requestedFinish?.toLowerCase()) || finishButtons[0];
    if (initialFinish) selectProductFinish(initialFinish);
    productRoot.addEventListener('click', async (event) => {
      const row = event.target.closest('[data-variant-row]');
      if (!row) return;
      const quantity = qs('[data-quantity]', row);
      if (event.target.closest('[data-quantity-minus]')) quantity.value = Math.max(1, Number(quantity.value) - 1);
      if (event.target.closest('[data-quantity-plus]')) quantity.value = Math.min(999, Number(quantity.value) + 1);
      const add = event.target.closest('[data-add-variant]');
      if (!add) return;
      add.disabled = true;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(add.dataset.variantId), quantity: Math.max(1, Number(quantity.value) || 1) }] })
        });
        if (!response.ok) throw new Error('Unable to add item');
        const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        const cart = await cartResponse.json();
        qsa('[data-cart-count]').forEach((badge) => { badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; });
        add.textContent = 'Added ✓';
        add.classList.add('added');
        setTimeout(() => { add.textContent = 'Add +'; add.classList.remove('added'); add.disabled = false; }, 1400);
      } catch {
        add.textContent = 'Try again';
        add.disabled = false;
      }
    });
  }

  qsa('[data-cart-minus], [data-cart-plus]').forEach((button) => button.addEventListener('click', () => {
    const input = qs('input', button.parentElement);
    const delta = button.hasAttribute('data-cart-minus') ? -1 : 1;
    input.value = Math.max(0, Math.min(999, Number(input.value) + delta));
  }));
})();
